

import './App.css';
 

import FsWinManager from './components/render/FsWinManager.js'

import { Menu, Dropdown ,Spin} from '@jd/find-react';
 
 import { Button } from '@jd/find-react';
 

import html2canvas from 'html2canvas';
 


import {
  IconFont
} from '@jd/find-react';
 
import React from 'react';

 
import KeeVue from './components/base/KeeVue.js'

import FsView from './components/render/FsView'

import FsMainMenu from './components/element/FsMainMenu.js'

import KinerGuideView from './KinerGuide/KinerGuideView.js'

import $ from 'jquery';


class FsMainFrame extends KeeVue {
	constructor(props) {
		super(props);
		this.state = {
			appId: '2021031708594945141281972480-CSY',
			code: 'cityDriverInfo/',

			keePage: null,
			components: [],
			component:{
				cp:{}
			},
			activeComponent: null,
			controller: {
				showSource: false,
				vueSource: "",
			},
			currentUrl:'',
			showReact:false,
			vueJsArray:[],
			vueloadedCount:0,
			loadUrlinfo:'',
			loadUrlinfo2:'',
			mainInfo:null,
			clientConfig:{},
			isCollapse:false,
			
			isFixedMenu:true,
			showDevButton:false,
		}

		this.myRef = React.createRef();

	}
	getJbCode=(ret )=>{
		 console.log("ret.sdk=="+ret.sdk);
		 const getAuthorizationCode = window.JZB_JSSDK.login.getAuthorizationCode;
		 if(ret.sdk=='0.0.3')
		 {
			 
			
			 
			 var options = {
			                appKey:ret.appKey,
			                callback:  (res)=> {
			                    var text = JSON.stringify(res);
			                    var obj = JSON.parse(text);
			                    if (obj.statusCode != 0) {
			                        this.state.loadUrlinfo="获取用户信息失败";
			                        this.state.loadUrlinfo2="获取用户信息失败";
									this.refresh();
			                        return;
			                    } 
								
								this.doRequest(ret.passportUrl+"/login/loginByJingzhiban",(retjingzhiban)=>{											
									if(retjingzhiban.success)
									{
										// 启动APP
										//this.startLoadApp();
										this.state.loadUrlinfo="startLoadApp";
										this.refresh();
										// this.startLoadApp(ret);
										 this.init("",ret);
									}
									else
									{
										this.state.loadUrlinfo="fail";
										this.state.loadUrlinfo2=retjingzhiban.message;
										this.refresh();
										 
									}
									
								},{
									code:obj.code,
									keyName:ret.keyName
								})
								
			                }
			            };
			            // FocusSDK.getAppRuntimeEnv(console.log);
			            getAuthorizationCode(options);
						
						return ;
		}
		  
		
		var getCode = getAuthorizationCode(ret.appKey);
		
		this.state.loadUrlinfo="code："+getCode?'true':'false';
		this.refresh();
		
		
		if(getCode)
		{
			getCode.then(res => {
							// res 内取code 
							var rjson = JSON.parse(res);
							var code = rjson.content.code;
							var content="获取到code："+code;
							 
							this.doRequest('/sysClientLog/save', function(data) {}, {
								content: content,
								platform: 'web',
								userId: window.currentUserId,
								type: 'info'
							});
							this.state.loadUrlinfo="/login/loginByJingzhiban";
							this.refresh();
							this.doRequest(ret.passportUrl+"/login/loginByJingzhiban",(retjingzhiban)=>{											
								// if(ret.success)
								// {
								// 	// 启动APP
								// 	//this.startLoadApp();
								// }
								this.state.loadUrlinfo="startLoadApp";
								this.refresh();
								this.startLoadApp(ret);
								
								// this.init("",ret);
							},{
								code:code,
								keyName:ret.keyName
							}) 
							 
						}).catch(err => {
							this.state.loadUrlinfo="获取用户信息失败";
							this.state.loadUrlinfo2="获取用户信息失败";
							this.showMessage("获取用户信息失败"+err.message);
							this.refresh();
							var content="获取用户信息失败" + JSON.stringify(err?err:'');
							this.doRequest('/sysClientLog/save', function(data) {}, {
								content: content,
								platform: 'web',
								userId: window.currentUserId,
								type: 'info'
							});
							
						    console.log("获取用户信息失败" + JSON.stringify(err?err:'')); 
							
							if(!this.loseTimes)
								
							{
								this.loseTimes = 0;
							}
							this.loseTimes++;
							if(this.loseTimes<5)
							{
								this.getJbCode(ret);
							}
						})
						
		}
		else{
			this.state.loadUrlinfo='获取用户code失败！';
			this.refresh();
		}
		
	}
	componentDidMount() {
		
		window.showMainFrame = true;
		
		$("body").css("overflow-y","hidden");
		
		// 设置feasApp的样式
		$("body").addClass("jz-new-body-bg");
		
		
		document.addEventListener('keydown',this.onKeyDown);
		
		// document.addEventListener('keyup',this.onKeyUp);
		
		window.closeShowDevBtn= true;

		this.fileCount = 100;
	// if(window.wx&&window.wx.miniProgram)
	// {
	// 	wx.miniProgram.getEnv(function(res) {
	// 	if(res.miniprogram){
	// 	   window.isMp= true;
		    
		
	// 	}else{
	// 	    //false代表在公众号里
	// 	 window.isMp= false;
	// 	}});
	// }
		
		
	 
		var url = window.rootWebPath+"/clientConfig/getMap";
		 // var url = window.location.protocol+"//"+window.location.host+"/clientConfig/getMap";
		 if(process.env.NODE_ENV=='development')
		 {
			 window.rootUri=window.webUrl;
			 url = window.webUrl+"/clientConfig/getMap";
		 }
		 else
		 {
			 window.rootUri=window.rootWebPath;
		 }
		 
		let protocolStr = document.location.protocol;
		if(protocolStr == "https:")
		{ 
		   window.rootUri = window.rootUri.replace("http://","https://");
		}
		else
		{
			window.rootUri = window.rootUri.replace("https://","http://");
		}
		 
		 
	
		 // 加载京智办的sdk
		 
		 this.doRequest(url,(ret)=>{
			 
			 
			 if(ret)
			 {
				 window.tid = ret.tid;
				 window.keyName = ret.keyName;
				 // window.rootUri = ret.rootWebPath;
				 window.rootClientWebPath = window.rootWebPath;
				 
				 window.ClientInsConfig = ret;
				  
				 window.ServerConfig = ret;
				 
				 if(ret&&ret.gloabalMap)
				 {
				 	for(let p in ret.gloabalMap)
				 	{
						if(process.env.NODE_ENV=='development'&&p=="webUrl")
						{
						 
							continue;
						} 
				 		window[p] = ret.gloabalMap[p];
						 
				 	} 
				 	
				 	
				 }
				 
				 window.clientMap = ret;
				 window.SERVER= ret;
				 
				 
			 }
			 
			 
			 
			 if(window.isMp)
			 {
			 	this.state.loadUrlinfo2="京邻里";
			 			 
			 			 
			 	this.refresh();
			 			 
			 	this.init("",ret);
			 	return;
			 }
			 
			 
			 
			 if(this.getUrlParameter("from")!="short")
			 {				 //https://focus-desktop.s3.cn-north-1.jdcloud-oss.com/gwork/jssdk/JZB-JSSDK-0.0.4.js
			 //https://oss.jzb.beijing.gov.cn/focus-desktop/gwork/jssdk/JZB-JSSDK-0.0.3.js
				 var sdkUrl = "https://focus-desktop.s3.cn-north-1.jdcloud-oss.com/gwork/jssdk/test/JZB-JSSDK-1.0.4-beta.all.js";
				 if(ret.pcSdkUrl)
				 {
					sdkUrl = ret.pcSdkUrl;
				 }
				 
				if(!ret.appKey)
				{
					this.init(url,ret);
					return ;
				}
				 
			 	this.loadJs(sdkUrl,()=>{
					
					if(!window.isMp&&window.JZB_JSSDK&&window.JZB_JSSDK.login)
					{
						console.log(" pc duan ");
						//  PC 
						this.state.loadUrlinfo="jssdk getting code";
						this.refresh();
						
						if(this.getUrlParameter("from")!="short")
						{
							console.log(" pc duan 2222");
							this.getJbCode(ret);
						}
						else
						{ } 
						 
						return ;
					}
					else
					{
						this.init(url,ret);
					}
					
					 
			 		
			 		// // 回调处理
			 		// setTimeout(()=>{
			 		// 	 this.init(url,ret);
			 		// },50)
			 	})
			 }
			 else
			 { 
				if(this.getUrlParameter("wx")=="1" || window.isMp)
				{
					//  
					 
					this.init(url,ret);
				 
					
					return ;
				}
			 			 // 移动提供jssdk的js文件，https://eepaas-public.s3.cn-north-1.jdcloud-oss.com/JSSDK/JDME-JSSDK-1.0.11.js，试一下这个
			 			 
			 	// this.loadJs("https://eepaas-public.s3.cn-north-1.jdcloud-oss.com/JSSDK/JDME-JSSDK-1.0.11.js",()=>{
			 	this.loadJs("https://eepaas-public.s3.cn-north-1.jdcloud-oss.com/JSSDK/example/JDME-JSSDK.js",()=>{	
			 				
							
							if(this.getUrlParameter("from")=="short"&&!window.isMp)
							{
								//alert("从移动端，不是小程序")
								// 从移动端，不是小程序
								const param = {
								appKey:ret.appKey,
								callback:  (result)=> {
								        //alert(JSON.stringify(result));
										
										if(result&&result.code)
										{
											var code = result.code;
											var content="获取到code："+code;
											
											window.jzbCode = code;
											 
											this.doRequest('/sysClientLog/save', function(data) {}, {
												content: content,
												platform: 'web',
												userId: window.currentUserId,
												type: 'info'
											});
											this.state.loadUrlinfo="/login/loginByJingzhiban";
											this.refresh();
											this.doRequest(ret.passportUrl+"/login/loginByJingzhiban",(retjingzhiban)=>{											
												// if(ret.success)
												// {
												// 	// 启动APP
												// 	//this.startLoadApp();
												// }
												// this.state.loadUrlinfo="startLoadApp";
												// this.refresh();
												// this.startLoadApp(ret);
												
												setTimeout(()=>{
													 this.init(url,ret);
												},150)
												
											},{
												code:code,
												keyName:ret.keyName
											}) 
											 
										}
										else
										{
											this.state.loadUrlinfo="获取code失败！";
											this.refresh();
										} 
								      }
								    };
								window.jme.login.getAuthorizationCode(param);
								
								setTimeout(()=>{
									if(!window.jzbCode)
									{
										this.state.loadUrlinfo="";
										this.state.loadUrlinfo2="请使用京办APP扫码";
										this.refresh();
									}
									
								},2000)
								
								 
								return ;
							}
							else
							{
								if(this.getUrlParameter("from")=="short"&&window.isMp)
								{
									setTimeout(()=>{
										 this.init(url,ret);
									},150)
								}
								
							}
							
			 				
			 				
			 				
			 			})
			 	
			 }
			 
			 });
		
		
		// 提前准备好icon列表
		// this.doRequest("/sysPrivilege/getIconLibs", (list) => {
		// 	// that.iconList = list; 
		// 	window.alliconList = list;  
		// });
		 
		
		this.onEvent("getDomImg",(domId,callback)=>{
			 {
				let dom = document.getElementById(domId);
				html2canvas(dom, {
				  width: dom.clientWidth,
				  height: dom.clientHeight,
				  scrollY: 0,
				  scrollX: 0,
				}).then(canvas => {
				  let tempSrc = canvas.toDataURL('image/jpg');
				  //console.log("imgimg:"+tempSrc);
				  //currentPage.imgSrc = tempSrc; 
				  
				  callback(tempSrc);
				  
				});
			}
		})
		
		this.watchTokenChange();
		console.log("mount执行一次定时任务：")
		 
		  
	}
	
	onKeyDown=(event)=>{
		console.log("down"+event.keyCode);
		if(!this.downKeys)
		{
			this.downKeys ={};
		}
		
		this.downKeys["key"+event.keyCode] =true;
		  
		if(this.downKeys["key17"] )
		{ 
			if(window.mainVueApp)
			{
				 this.state.showDevButton = !this.state.showDevButton;
				 this.refresh();
				 window.mainVueApp.sendEvent("showDevButton",this.state.showDevButton);
			}
			this.downKeys["key17"] = false;
		}  
	}
	
	// onKeyUp=(event)=>{
	// 	console.log("up"+event.keyCode);
	// 	if(!this.downKeys)
	// 	{
	// 		this.downKeys ={};
	// 	}
		
	// 	this.downKeys["key"+event.keyCode] =false;
		  
	// 	if(event.keyCode==17)
	// 	{ 
	// 		if(window.mainVueApp)
	// 		{
	// 			this.state.showDevButton = false;
	// 			this.refresh();
	// 			window.mainVueApp.sendEvent("showDevButton",false);
	// 		}
	// 		this.downKeys["key17"] = false;
	// 	}  
	// }
	
	
	
	
	init=(url,ret)=>{
		
		this.beginInit = true;
		 
		this.fileCount = 100;
		
		this.state.loadUrlinfo="/clientConfig/getMap";
		// this.doRequest(url,(ret)=>{
			
			this.state.loadUrlinfo="/clientConfig/getMap-ok";
			this.refresh();
		
			this.state.clientConfig = ret;
			
			
			$("#feasApp").addClass(ret.mainClassName);
			$("#win-manager-div").addClass(ret.mainClassName);
			
			let isPreview = this.getUrlParameter("isPreview");
			
			if(isPreview)
			{
				$("#feasApp").addClass("preview-mode");
				$("#win-manager-div").addClass("preview-mode");
			}
			
			
			this.vueJsArray=[];
			 
			window.disableVue = ret.disableVue;
			
			let protocolStr = document.location.protocol;
			if(protocolStr == "https:")
			{ 
			   window.rootUri = window.rootUri.replace("http://","https://");
			}
			else
			{
				window.rootUri = window.rootUri.replace("https://","http://");
			}
			 
			this.refresh();
			
			let appCodeUrl = this.getUrlParameter("appCode");
			
				window.isReport = appCodeUrl.indexOf("REPORT_")==0
			
			// 然后获取用户信息，如果获取成功显示，如果获取失败，跳转到登录页面
		 
		 //alert("test:::::/mainFrame/getMainInfo");
		 
		 
			this.doRequest("/mainFrame/getMainInfo",(mainInfo)=>{
				 
				//alert("test:::::"+JSON.stringify(mainInfo)); 
				let access_token = sessionStorage.getItem('access_token');
				if(access_token&&mainInfo&&mainInfo.success==false&&window.mainInfoConfigData)
				{
					// 清空缓存，避免还从本地获取
					window.mainInfoConfigData="";
					console.log("获取数字证书："+access_token)
					this.doRequest("/login/loginByTianquan",(userSession)=>{
						 	//alert("881test:::::/mainFrame/getMainInfo");
							this.init(url,ret);
					},{
						code:access_token
					})
					return;
				}
				 
				
				
				if(mainInfo&&mainInfo.retData)
				{
					for(let p in mainInfo.retData)
					{
						if(p=='allDicts'||p=="userPermissions")
						{
							window[p] = JSON.parse(mainInfo.retData[p]);
							
							if(p=="allDicts")
							{
								// 将数组转成对象方式：
								window.allDictsMap = {};
								
								for(let m=0;m<window.allDicts.length;m++)
								{
									let d = window.allDicts[m];
									
									if(!window.allDictsMap[d.dictTypeName])
									{
										window.allDictsMap[d.dictTypeName]={};
									}
									 window.allDictsMap[d.dictTypeName][d.name]=d.title;
								}
							}
							
						}
						else
						{
							window[p] = mainInfo.retData[p];
						}
						
						
					}
				}
				this.vueJsArray=[];
				
				let protocolStr = document.location.protocol;
				if(protocolStr == "https:")
				{ 
				   window.rootUri = window.rootUri.replace("http://","https://");
				}
				else
				{
					window.rootUri = window.rootUri.replace("https://","http://");
				}
				
				// addNewPointIp,只有在京智平台下才访问
				if(window.clientMap&&window.clientMap.checkMyIps&&"2018091117550990560-CSY"==window.tid)
				{
					let ips = window.clientMap.checkMyIps.split(",");
					
					for(let p=0;p<ips.length;p++)
					{
						let ip = ips[p];
						$.ajax({
							url: ip,
							type: 'POST', 
							cache: false,
							dataType: "html", 
							xhrFields: {withCredentials: true},
							success:  (ret)=> { 
								this.doRequest("/resVpcGroupRule/addNewPoint",(ret2)=>{
									if(ret2&&!ret2.success)
									{
										this.showMessage(ret2)
									}
								},{
									ip:ret
								})
							},
							error: function(XMLHttpRequest, textStatus, errorThrown) { }
						});
						
					}
					
				} 
			 
				// 登录到gitea服务，获取到登录态
				console.log(window.rootUri+"/gitlogin");
				if(window.clientMap&&window.clientMap.autoLoginGitea)
				{
					$.ajax({
						url: window.rootUri+"/gitlogin",
						type: 'POST', 
						cache: false,
						dataType: "html", 
						data: {
						
						},
						xhrFields: {withCredentials: true},
						success:  (ret)=> {  
						 
						},
						error: function(XMLHttpRequest, textStatus, errorThrown) { 
							
						}
					});
				}
				
				
				if(!window.userPermissions)
				{
				//	this.vueJsArray.push(window.rootUri+"/mainFrame/config?_t=4.20210825102000");
					 
				}
				
				let  vueFileNames = "";
			vueFileNames += "kee-string.vue"; 
			vueFileNames += ",fs-icon.vue,fs-alert.vue,fs-pic-select.vue,fs-table-tree.vue"; 
			vueFileNames += ",fs-tree.vue,fs-table.vue,fs-table-col.vue,"; 
			vueFileNames += "fs-dropdown.vue,fs-select.vue,fs-cascader.vue,fs-upload.vue,fs-ztree.vue,fs-scroll.vue"; 
			vueFileNames += ",fs-layout.vue,fs-tree-menu.vue,fs-text.vue,fs-button.vue,fs-view.vue"; 
			vueFileNames += ",fs-pic.vue,fs-video.vue,fs-rect.vue,fs-form.vue,fs-tabs.vue,feas-page.vue,";
 			vueFileNames += ",fs-dialog.vue,fs-border-layout.vue,";
			vueFileNames+= "fs-list.vue,fs-menu-item.vue,fs-win-manager.vue,"; 
 		    vueFileNames+= "fs-box.vue,fs-card.vue,fs-color.vue,fs-code-editor.vue,fs-html-editor.vue";
				
				
				
				if(!ret.disableVue)
				{ 
					if(window.location.host.indexOf("cms.xjoycity.com")!=-1)
					{
						let vueJs = vueFileNames.split(",");
						for(let item of vueJs)
						{
							if(item)
							{
								console.log("jiazai:"+window.rootWebPath+"/front/_vue/"+item.replace(".vue",".js")+"?_t="+window.PLATFORM_BUILD_VERSION+"&tid="+window.tid+"");
									this.vueJsArray.push(window.rootWebPath+"/front/_vue/"+item.replace(".vue",".js")+"?_t="+window.PLATFORM_BUILD_VERSION+"&tid="+window.tid+"");
								
							}
						}
						
					}
					else
					{
						// this.vueJsArray.push(window.rootUri+"/api/vueComponentJs/getByCombineJs?_t="+window.PLATFORM_BUILD_VERSION+"&tid="+window.tid+"");
						
						this.vueJsArray.push(window.rootUri+"/vResList/getByCombineJs?_t="+window.PLATFORM_BUILD_VERSION+"&tid="+window.tid+"");
						
					}
					this.vueJsArray.push(window.rootWebPath+"/front/fs-input.js?_t="+window.BUILD_VERSION+"&tid="+window.tid+"");
					this.vueJsArray.push(window.rootWebPath+"/front/fs-render.js?_t="+window.BUILD_VERSION+"&tid="+window.tid+""); 
					this.vueJsArray.push(window.rootWebPath+"/front/_js/xterm.js");
					 
					// this.vueJsArray.push("/front/fs-input-nutui.js?_t=4.20210825102000&tid="+window.tid+"");
					//this.fileCount  = 3;
				
				}
				
				this.fileCount=this.vueJsArray.length+1;
				
				if(window.clientMap&&window.clientMap.customCssUrl)
				{
					let cssUrls = window.clientMap.customCssUrl.split(",");
					this.fileCount+=cssUrls.length; 
				}
				
				 
			 
				this.refresh();
				 var fromShort=this.getUrlParameter("from");
				 
				  // alert("window.isMp:"+window.isMp);
				//alert(JSON.stringify(mainInfo));
				if(mainInfo.success&&fromShort!='short')
				{
					
				 
					// console.log("_publicKey222:"+window._publicKey);
					
					
					window.mainInfo= mainInfo;
					// 获取成功
					this.state.mainInfo = mainInfo.retData;
					window.document.title = mainInfo.retData.systemTitle;
					console.log("window.document.title:"+ mainInfo.retData.systemTitle);
					//this.selfSetIcon(this.state.clientConfig.fsUrl+this.state.mainInfo.sys.logo);
					
					
					 
						if(this.state.mainInfo.sys.icon)
						{
							this.selfSetIcon(this.state.clientConfig.fsUrl+this.state.mainInfo.sys.icon);
						}
						else
						{
							if(ret.tabIcon)
							{
								this.selfSetIcon(ret.tabIcon);
							}
							else
							{
								this.selfSetIcon(this.state.clientConfig.fsUrl+this.state.mainInfo.sys.logo);
							}
							
						}
						
						
					 
					
					//alert(JSON.stringify(this.state.mainInfo));
					this.startLoadApp(ret);
				}
				else
				{ 
					//如果是在京智办里面，则直接获取code进行登录操作，如果登录失败，则跳转到登录页面
					this.state.loadUrlinfo="/mainFrame/getMainInfo-ok2"+mainInfo.success;
					this.refresh();
					
					if(window.isMp||this.getUrlParameter("wx")=="1"||this.getUrlParameter("auto")=="true")
					{
						
							// 不用登陆！或则严格，不显示
							
							// 需要注册成为游客；
							var youkename = localStorage.getItem("youkename");
							if(!youkename)
							{ 
							 youkename = this.getRandString();
							 localStorage.setItem("youkename",youkename);
							}
							this.state.loadUrlinfo= "/login/registYouke";
							this.refresh();
							this.doRequest(ret.passportUrl+"/login/registYouke?name="+youkename+"&keyName="+ret.keyName,(retLogin)=>{
								this.state.loadUrlinfo= "retLogin";
								 
								if(retLogin.success)
								{
									// 注册并登陆成功
									this.state.loadUrlinfo= "retLogin.success";
									this.startLoadApp(ret);
								}
								else
								{
									this.state.loadUrlinfo= "retLogin.false";
								}
								 
								this.refresh();
							})
						 
						
						return ;
					}
					
					if(this.getUrlParameter("from")=="short"&&!window.isMp)
					{
						//alert("从移动端，不是小程序")
						// 从移动端，不是小程序
						const param = {
						appKey:ret.appKey,
						callback:  (result)=> {
						        //alert(JSON.stringify(result));
								
								if(result&&result.code)
								{
									var code = result.code;
									var content="获取到code："+code;
									
									window.jzbCode = code;
									 
									this.doRequest('/sysClientLog/save', function(data) {}, {
										content: content,
										platform: 'web',
										userId: window.currentUserId,
										type: 'info'
									});
									this.state.loadUrlinfo="/login/loginByJingzhiban";
									this.refresh();
									this.doRequest(ret.passportUrl+"/login/loginByJingzhiban",(retjingzhiban)=>{											
										// if(ret.success)
										// {
										// 	// 启动APP
										// 	//this.startLoadApp();
										// }
										this.state.loadUrlinfo="startLoadApp";
										this.refresh();
										this.startLoadApp(ret);
									},{
										code:code,
										keyName:ret.keyName
									}) 
									 
								}
								else
								{
									this.state.loadUrlinfo="获取code失败！";
									this.refresh();
								} 
						      }
						    };
						window.jme.login.getAuthorizationCode(param);
						
						setTimeout(()=>{
							if(!window.jzbCode)
							{
								this.state.loadUrlinfo="";
								this.state.loadUrlinfo2="请使用京办APP扫码";
								this.refresh();
							}
							
						},2000)
						
						 
						return ;
					}
					console.log("!window.isMp&&window.JZB_JSSDK&&window.JZB_JSSDK.login=="+(!window.isMp&&window.JZB_JSSDK&&window.JZB_JSSDK.login));
					if(!window.isMp&&window.JZB_JSSDK&&window.JZB_JSSDK.login)
					{
						console.log(" pc duan ");
						//  PC 
						this.state.loadUrlinfo="jssdk getting code";
						this.refresh();
						
						if(this.getUrlParameter("from")!="short")
						{
							console.log(" pc duan 2222");
							this.getJbCode(ret);
						}
						else
						{ } 
						 
						return ;
					}
					else
					{
					this.state.loadUrlinfo="非京办APP";
					this.refresh();
					if(this.getUrlParameter("appName").indexOf("REPORT_")!=-1||this.getUrlParameter("auto")=="true"||this.getUrlParameter("appCode").indexOf("REPORT_")!=-1)
					{
						// 不用登陆！或则严格，不显示
						
						// 需要注册成为游客；
						var youkename = localStorage.getItem("youkename");
						if(!youkename)
						{ 
						 youkename = this.getRandString();
						 localStorage.setItem("youkename",youkename);
						}
						this.state.loadUrlinfo= "/login/registYouke";
						this.refresh();
						this.doRequest(ret.passportUrl+"/login/registYouke?name="+youkename+"&keyName="+ret.keyName,(retLogin)=>{
							this.state.loadUrlinfo= "retLogin";
							 
							if(retLogin.success)
							{
								// 注册并登陆成功
								this.state.loadUrlinfo= "retLogin.success";
								this.startLoadApp(ret);
							}
							else
							{
								this.state.loadUrlinfo= "retLogin.false";
							}
							 
							this.refresh();
						})
						return ;
					}
					else
						{
							var fromPlatform = this.state.clientConfig.fromPlatform;
							
							if(!fromPlatform)
							{
								fromPlatform = "";
							}
							 
								let loginUrl = ret.passportUrl+"/login?fromPlatform="+fromPlatform+"&tid="+ret.tid+"&keyName="+ret.keyName;
								loginUrl+="&token="+this.getUrlParameter("token");
								if(this.getUrlParameter("focus-open-code"))
								{
									loginUrl+="&focus-open-code="+this.getUrlParameter("focus-open-code");
								}
								
								loginUrl+="&returnUrl="+window.location.href;
								
								window.loginUrl = loginUrl;
								
								if(loginUrl.indexOf("http"))
								{
									window.location.href=loginUrl.replace("http:",document.location.protocol);
								}
								else
								{
									window.location.href=loginUrl;
								}
								
								
								return ;
						}
						
						
					} 
					 
				}
				 
				
				this.refresh();
				
				this.beginRefresh();
				
			})
		// })
		
	}
	
	beginRefresh=()=>{
		
		console.log("refresh mainframe")
		this.refresh();
		if(!this.stopRefresh)
		{
			setTimeout( 
				this.beginRefresh
			 ,1000);
		}
	}
	
	watchTokenChange(){
		
		
		let ck = this.getCookie("token");
		 
		if(!window.currentToken||window.currentToken=="\"\"")
		{
			if(window.keyName)
			{
				window.currentToken = ck; 
			}
			
		}
				 
		//alert(window.currentToken!="");
		if(!window.isPub&&window.keyName&&ck&&ck!='""'&&window.currentToken&&window.currentToken!="\"\""&&window.currentToken!=ck)
		{
			// alert( "登录状态变化，将自动刷新页面1!" );
			// debugger;
			//window.location.reload();
			return ;
		}
		
		window.setTimeout(()=>{
			
			//this.watchTokenChange();
			
		},2000);
		
	}
	
	doMainInfo=(mainInfo,ret)=>{
		
			
			 this.state.loadUrlinfo= "/getMainInfo-ret"+mainInfo.success;
			 this.refresh();
			//alert(JSON.stringify(mainInfo));
			
			var fromShort=this.getUrlParameter("from");
			 
			   
			//alert(JSON.stringify(mainInfo));
			if(mainInfo.success) 
			{
				 
				console.log("_publicKey:"+window._publicKey);
				
				// 获取成功
				this.state.mainInfo = mainInfo.retData;
				window.document.title = mainInfo.retData.systemTitle;
				console.log("window.document.title222:"+ mainInfo.retData.systemTitle);
				
				
				 
					if(this.state.mainInfo.sys.icon)
					{
						this.selfSetIcon(this.state.clientConfig.fsUrl+this.state.mainInfo.sys.icon);
					}
					else
					{
						if(ret.tabIcon)
						{
							this.selfSetIcon(ret.tabIcon);
						}
						else
						{
							this.selfSetIcon(this.state.clientConfig.fsUrl+this.state.mainInfo.sys.logo);
						}
						
					}
					 
				 
				// 代表登录成功
				window.loginedTokenNew  = true;
				
				
				//alert(JSON.stringify(this.state.mainInfo));
			}
			else
			{ 
				//如果是在京智办里面，则直接获取code进行登录操作，如果登录失败，则跳转到登录页面
				
			 
				{
					var fromPlatform = this.state.clientConfig.fromPlatform;
					
					if(!fromPlatform)
					{
						fromPlatform = "";
					}
					 
					 
						var loginUrl = ret.passportUrl+"/login?fromPlatform="+fromPlatform+"&tid="+ret.tid+"&keyName="+ret.keyName;
						loginUrl+="&returnUrl="+window.location.href;
						
						//alert("loginUrl:"+loginUrl);
						
						window.loginUrl = loginUrl;
						
						window.location.href=loginUrl.replace("http:",document.location.protocol);
						return ;
				} 
				 
			}
			this.state.loadUrlinfo= "kaishiload";
			this.refresh();
			
			this.vueJsArray.map((item,index)=>{
				this.state.loadUrlinfo= ""+item;
				 
				this.loadJs(item,()=>{
					this.state.vueloadedCount++;
					this.refresh();
					this.showVueViewUrl("");
					
					 
					window.tid = ret.tid;
					window.keyName = ret.keyName;
					// window.rootUri = ret.rootWebPath;
					window.rootClientWebPath = window.rootWebPath;
					
					let protocolStr = document.location.protocol;
					if(protocolStr == "https:")
					{
					   window.rootClientWebPath = window.rootClientWebPath.replace("http://","https://");
					   window.rootUri = window.rootUri.replace("http://","https://");
					}
					
				});
			})
			
			let protocolStr = document.location.protocol;
			if(protocolStr == "https:")
			{ 
			   window.rootUri = window.rootUri.replace("http://","https://");
			}
			
			
			// this.loadCss(window.rootUri+"/api/vueComponentJs/getByCombineCss?_t="+window.PLATFORM_BUILD_VERSION+"&tid="+window.tid+"",()=>{
			// 	console.log("done:css");
			// 	//this.state.vueloadedCount++;
			// 	this.showVueViewUrl("");
			// 	this.refresh();
				
			// });
			
			this.loadCss(window.rootWebPath+"/front/_css/xterm.css",()=>{
				console.log("done:css");
				//this.state.vueloadedCount++;
				this.showVueViewUrl("");
				this.refresh();
				
			});
			
			if(window.clientMap.thirdLibs)
			{
				for(let i=0;i<window.clientMap.thirdLibs.length;i++)
				{
					console.log("load lib:"+window.clientMap.thirdLibs[i].url);
					if(window.clientMap.thirdLibs[i].name=='js')
					{
						this.loadJs(window.clientMap.thirdLibs[i].url,()=>{
							console.log("finish url:"+window.clientMap.thirdLibs[i].url);
						});
					}
					if(window.clientMap.thirdLibs[i].name=='css')
					{
						this.loadCss(window.clientMap.thirdLibs[i].url,()=>{
							console.log("finish url:"+window.clientMap.thirdLibs[i].url);
						});
					}
					
					if(window.clientMap.thirdLibs[i].name=='woff2'||window.clientMap.thirdLibs[i].name=='woff')
					{ 
						let content = "";
						content +="@font-face {  ";
						content +="    font-family: '"+window.clientMap.thirdLibs[i].title+"';  ";
						content +="    src: url('"+window.clientMap.thirdLibs[i].url+"') format('"+window.clientMap.thirdLibs[i].name+"');"; 
						content +="    font-weight: normal;  ";
						content +="    font-style: normal;  ";
						content +="}"; 
						let style = document.createElement('style');   
						// 为style元素添加CSS内容  
						style.innerHTML =  content; 
						// 将style元素添加到head元素中  
						document.head.appendChild(style); 
					}
					
					
				}
			}
			
			// this.loadCss(window.rootUri+"/api/vueComponentJs/getByAppBusinessCss?_t=8&tid="+window.tid+"",()=>{
				 
			// 	console.log("done:css");
			// 	this.state.vueloadedCount++;
			// 	this.showVueViewUrl("");
			// 	this.refresh();
				
			// });
			// this.state.vueloadedCount++;
			
			
			if(window.MAX_KEE_PAGE_TIME)
			{
				window.MAX_KEE_PAGE_TIME = window.MAX_KEE_PAGE_TIME.replace(" ","");
			}
			
			$.ajax({
				url: window.rootUri + "/api/vueComponentJs/getByAppBusinessCss?pt="+window.MAX_KEE_PAGE_TIME+"&tid="+window.tid,
				cache: true,
				type: 'get',
				dataType: "html",
				data: { 
				},
				success: (str)=> {
					
					this.state.vueloadedCount++;
					 var nod = document.createElement("style");
					nod.type = "text/css";
					if(nod.styleSheet) { //ie下  
						nod.styleSheet.cssText = str;
					} else {
						nod.innerHTML = str; //或者写成 nod.appendChild(document.createTextNode(str))  
					}
					//document.getElementsByTagName("head")[0].appendChild(nod);
					
					document.body.parentNode.appendChild(nod);
					this.refresh();
				  
				},
				error: function(XMLHttpRequest, textStatus, errorThrown) {
					 
					console.log("网络请求错误getByAppBusinessCss");
					module.data = "";
				}
			});
			
			// 增加用户自定义的css
			if(window.clientMap&&window.clientMap.customCssUrl)
			{
				let cssUrls = window.clientMap.customCssUrl.split(",");
				
				for(let ii=0;ii<cssUrls.length;ii++)
				{
					let cssUrl = cssUrls[ii];
					
				
				if(cssUrl.indexOf("http")!=0)
				{
					cssUrl = window.rootUri+cssUrl;
				}
				
				if(cssUrl.indexOf("?")==-1)
				{
					cssUrl+="?";
				}
				
				cssUrl+="&pt="+window.MAX_KEE_PAGE_TIME;
				
				$.ajax({
					url: cssUrl,
					cache: true,
					type: 'get',
					dataType: "html",
					data: { 
					},
					success: (str)=> {
						
						this.state.vueloadedCount++;
						 var nod = document.createElement("style");
						nod.type = "text/css";
						if(nod.styleSheet) { //ie下  
							nod.styleSheet.cssText = str;
						} else {
							nod.innerHTML = str; //或者写成 nod.appendChild(document.createTextNode(str))  
						}
						//document.getElementsByTagName("head")[0].appendChild(nod);
						
						document.body.parentNode.appendChild(nod);
						this.refresh();
					  
					},
					error: function(XMLHttpRequest, textStatus, errorThrown) {
						 
						console.log("网络请求错误getByAppBusinessCss");
						module.data = "";
					}
				});
				}
			}
			
			
			
			 
			 
			
			this.refresh();
			
		
	}

	startLoadApp=(ret)=>{
		
		
	 
			
			this.state.loadUrlinfo= "/getMainInfo";
			this.refresh();
			// 然后获取用户信息，如果获取成功显示，如果获取失败，跳转到登录页面
			
			if(window.mainInfo&&window.mainInfo.success)
			{
				this.doMainInfo(window.mainInfo,ret);
			}
			else
			{
				//需要先登录一下，然后再获取
				
				let data = sessionStorage.getItem('access_token');
				if(data)
				{
					console.log("获取数字证书："+data)
					this.doRequest("/login/loginByTianquan",(userSession)=>{
						 	//alert("881test:::::/mainFrame/getMainInfo");
							this.doRequest("/mainFrame/getMainInfo?_t=2",(mainInfo)=>{
								//alert("881test:::::"+JSON.stringify(mainInfo));
								this.doMainInfo(mainInfo,ret);
							}) 
					},{
						code:data
					})
				}
				else
				{
					//alert("881test:::::/mainFrame/getMainInfo");
					this.doRequest("/mainFrame/getMainInfo?_t=2",(mainInfo)=>{
						//alert("881test:::::"+JSON.stringify(mainInfo));
						this.doMainInfo(mainInfo,ret);
					})
				}
				  
				
			}
			
			
		
		
	}
	 
	 
  
 
	 onHashChange=(url,node)=>{
		 console.log("onHashChange执行一次定时任务："+url+(!this.beginInit||this.state.vueloadedCount!=(this.fileCount)||!this.state.mainInfo))
		 console.log("onHashChange执行一次定时任务：",this.beginInit,this.state.vueloadedCount,this.fileCount,this.state.mainInfo);
		 
		 if(url)
		 {
			 if(url.indexOf("jdccApp/")!=-1)
			 {
				 node = {
					 attributes:{
						 appType:"vue"
					 }
				 }
			 }
			 
			 if(url.indexOf("REPORT_")!=-1)
			 {
			 	node = {
			 		attributes:{
						appType:"React"
			 		}
			 	}
			 }
			 
			 if(url.indexOf("jzbFormTianbao")!=-1)
			 {
			 	node = {
			 		attributes:{
			 						appType:"vue"
			 		}
			 	}
			 }
			 
			 // 先暂时屏蔽，看看有没有什么问题
			 if(url.indexOf("2021_")!=-1)
			 {
			 	url = url.substring(url.indexOf("2021_")+5);
			 }
			 
			 if(url.indexOf("2018_")!=-1)
			 {
			 	url = url.substring(url.indexOf("2018_")+5);
			 }
			 
			 if(url.indexOf("_M::")!=-1)
			 {
			 	url = url.substring(url.indexOf("_M::")+1);
			 }
			 
		 }
		  
		 
		// if(!node)
		// {
		// 	node = this.currentNode;
		// }
		
		// this.currentNode = node;
		
		
		
		
	 
		
		if(!this.beginInit||this.state.vueloadedCount!=(this.fileCount)||!this.state.mainInfo)
		{
			// 可能还在加载中
						 setTimeout(()=>{
							 this.onHashChange(url,node);
						 },30);
						 return ;
		}
		
		// console.log("node.attributes.appType："+node.attributes.appType);
		// console.log("window.showReact"+window.showReact)
		
		// 判断node 是否是一个参数！
		
		if(!node||!(node&&node.attributes&&node.attributes.appType=='React'))
		{
			console.log("111");
			 // 看看vue资源加载好了没有 
			this.state.showReact= false;
			window.showReact= false;
			// 让vue的版本去渲染页面
			if(window.mainVueApp)
			{
				console.log("222");
				window.mainVueApp.currentUrl = url
				window.PageParameters = node;
				//window.mainVueApp.sendEvent("vueCurrentUrl",url);
				
				this.showVueViewUrl(url);
				setTimeout(()=>{
					window.PageParameters=null;
				},150);
			}
			else
			{
				console.log("333");
				window.vueCurrentUrl = url;
				//window.mainVueApp.sendEvent("vueCurrentUrl",url);
				this.showVueViewUrl(url);
			}
			$("#feasApp").show();
			this.state.currentUrl = "";
		 }
		 else
		 {
			 this.state.pageParameters = node;
			 this.state.showReact= true;
			 window.showReact= true;
			 this.state.currentUrl = url;
			 $("#feasApp").hide();
		 }
		
	 
		 this.refresh();
	 }
	 
	 showVueViewUrl=(url)=>{
		 
		console.log("showVue执行一次定时任务："+url)
		 
		 if(this.timerSvv)
		 {
			 clearTimeout(this.timerSvv);
		 }
		 this.timerSvv = null;
		 
		 let that = this;
		 
		 console.log("showVue执行一次定时任务：this.state.vueloadedCount="+this.state.vueloadedCount+"=="+this.fileCount)
		 if(this.state.vueloadedCount==(this.fileCount)&& typeof window.KeeVue=='function')
		 {
			 // 执行成功
			 
			 if(!window.mainVueApp&&!this.beginLoadVue)
			 { 
				this.beginLoadVue = true;
						//  window.mainVueApp.sendEvent("vueCurrentUrl",url);
						 setTimeout(()=>{
							 if(window.loadVueApp)
							 {
							 	console.log("loadVueApp执行一次定时任务：" );
							 	window.loadVueApp();
								that.refresh();
							 }
						 },100);
							
						 
						
			 }
		 }
		   
		 if(  window.mainVueApp)
		 { 
			 console.log("showVue执行一次定时任务：window.mainVueApp="+true+" window.showReact="+window.showReact );
		 	
			if(window.showReact== false)
			{console.log("sendEvent执行一次定时任务：",window.showReact)
				window.mainVueApp.sendEvent("vueCurrentUrl",url);
				
				this.refresh();
			}
			 
		 }
		 else
		 {
			  console.log("showVue执行一次定时任务：yanshi 300="+true)
		 	// setTimeout(()=>{
		 	// 	 this.showVueViewUrl(url); 
		 	// },100)
			
			if(!this.timerSvv)
			{
				this.timerSvv = setTimeout(()=>{
					
					console.log("执行一次定时任务：")
				   this.showVueViewUrl(url); 
				},300)
			}
			
		 }
	 }
	 
	 onClickChangeTheme=(key)=>{
		 
		 if($("#feasApp").hasClass("cityos"))
		 {
			 // 移除
			 $("#feasApp").removeClass("cityos");
			 $("#jz-main-body").removeClass("cityos");
			 window.clientMap.theme = "light";
			 this.refresh();
		 }
		 else
		 {
			 // 添加
			  $("#feasApp").addClass("cityos");
			  $("#jz-main-body").addClass("cityos");
			  window.clientMap.theme = "dark";
			  this.refresh();
			 
		 }
		 
	 }
	 
	 onClickChangePassword=(key)=>{
		 
		 
		 this.sendEvent("win.open"+( window.showReact?".react":""), {
		 	target: 'dialog',
		 	url: "M::sysUser/changePassword",
		 	data:  {
			 			title: '修改密码',
			 			size: 'normal',
			 			loadUrl: '/sysUser/get?id='  , 
			 			onChanged:  (ret, form)=> {
			 				this.showMessage(ret); 
			 				form.$emit("changed", ret)
			 			}
			 		},
		 	appCode: "sysUser",
		 }); 
		  
		 
		 }
		 onClickLogout = ()=>{
		  
		  
		  console.log("请求注销接口：")
		  
		  if(window.clientMap&&window.clientMap.autoLoginGitea)
		  { 
			   $.ajax({
			   	url: window.rootUri + "/gitserver/user/logout",
			   	cache: false,
			   	type: 'POST',
			   	dataType: "html",
			   	data: { 
					 "_csrf":window.getCookie("_csrf")
			   	},
			   	success: (str)=> { },
			   	error: function(XMLHttpRequest, textStatus, errorThrown) { }
			   }); 
			  		  
		  }
		 
		   
			  this.doRequest("/login/loginOut", (ret)=> {
			  	console.log("请求注销接口完成：",ret);
			  	
			  	window.delCookie(this.state.clientConfig.keyName+"_token");
			  	window.delCookie(this.state.clientConfig.keyName+"-token");
			  	window.delCookie(this.state.clientConfig.keyName+"_sessionKey");
			  	window.delCookie(this.state.clientConfig.keyName+"-sessionKey");
			  	
			  	// 删除imos登录态
			  	window.delCookie("x-imos-auth_token");
			  	
			  	// 删除gitea的登录态
			  	window.delCookie("i_like_gitea");
				
				window.delCookie("dright_authorization");
				
				window.sessionStorage.removeItem('access_token');  
			  	
			  	window.sessionStorage.clear(); //html5 session存储清除
			  			 
			  	 
			  	var loginUrl = this.state.clientConfig.passportUrl+"/login?tid="+this.state.clientConfig.tid+"&logOut=true&keyName="+this.state.clientConfig.keyName;
			  	loginUrl+="&returnUrl="+window.location.href;
			  	
			  	if(window.SERVER.logOutWithErp)
			  	{
			  	//erpsso.xjoycity.com/
			  	
			  	window.location.href="https://erpsso.xjoycity.com/jdErpSso/toLogout?returnUrl="+ encodeURIComponent( loginUrl.replace("http:",document.location.protocol));
			  	
			  	
			  		// window.location.href="https://ssa.jd.com/sso/logout?ReturnUrl="+ encodeURIComponent( loginUrl.replace("http:",document.location.protocol));
			  	}
			  	else
			  	{
			  		window.location.href=loginUrl.replace("http:",document.location.protocol);
			  	}
			  	
			  	
			  	//
			  	
			  });
			  		  
		   
		  
		 	
		 
		 
	 }
	 
	fixedMenu=()=>{
		
		// 盯住菜单
		
		this.state.isFixedMenu = !this.state.isFixedMenu;
		
		this.refresh();
		
		if(this.state.isFixedMenu)
		{
			console.log("执行 over");
			this.state.isCollapse=false;
			this.refresh();
			//$("#feasApp").css("left","240px");
			// $("#jz-left-body").css("width","240px");
			// $("#jz-left-body").removeClass("left-body-float" );
			$("body").removeClass("left-body-float" );
			$("body").removeClass("mouseover-left-body" );
		}
		else
		{
			// this.menuTimer = setTimeout(()=>{
				 
				{
					console.log("执行 out");
					this.state.isCollapse=true;
					this.refresh();
					//$("#feasApp").css("left","48px");
					// $("#jz-left-body").css("width","48px"); 
					// $("#jz-left-body").addClass("left-body-float" );
					$("body").addClass("left-body-float" );
				}
			// },100);
		}
		
		// this.state.isCollapse=!this.state.isCollapse;
		 
		// if(this.state.isCollapse)
		// {
		// 	$("#feasApp").css("left","54px");
		// 	$("#jz-left-body").css("width","54px"); 
		// }
		// else
		// {
		// 	$("#feasApp").css("left","240px");
		// 	$("#jz-left-body").css("width","240px");
		// }
		
		// this.refresh();
	}
	
	onMenuMouseOverFixedBtn=(e)=>{
		if(!this.state.isCollapse)
		{
			// 如果是展开状态，维持现状
			clearTimeout(this.menuTimer);
			
		}
		e.stopPropagation();
	}
	
	onMenuMouseOutFixedBtn=(e)=>{
		this.onMenuMouseOver();
		e.stopPropagation();
	}
	
	onMenuMouseOver=()=>{
		
		if(!this.state.isFixedMenu)
		{
			clearTimeout(this.menuTimer);
			
			if(this.state.isCollapse)
			{
				console.log("执行 over");
				this.state.isCollapse=false;
				this.refresh();
				// $("#feasApp").css("left","240px");
				// $("#jz-left-body").css("width","240px");
				$("#jz-left-body").css("z-index","101");
				 
				$("body").addClass("mouseover-left-body");
				
			}
			 
		}
		
		
	
	}
	
	onMenuMouseOut=()=>{
		// 如果非固定菜单，则自动消失
		if(!this.state.isFixedMenu)
		{
			this.menuTimer = setTimeout(()=>{
				if(!this.state.isCollapse)
				{
					console.log("执行 out");
					this.state.isCollapse=true;
					this.refresh();
					// $("#feasApp").css("left","48px");
					// $("#jz-left-body").css("width","48px"); 
					// $("#jz-left-body").addClass("left-body-float" );
					$("body").removeClass("mouseover-left-body" );
					
				}
			},100);
		}
		 
		
		
		
		
	}
 

	render() {
		 
		var fullPage = this.getQueryVariable("fullPage");
		
		 fullPage = /数正云/.test(navigator.userAgent)? 1 : this.getQueryVariable("fullPage");
		
		// 前端自适应https的问题
		if(window.fileUrl)
		{
			window.fileUrl=window.fileUrl.replace("http:",document.location.protocol);
			window.fileUrl=window.fileUrl.replace("https:",document.location.protocol);
			
		}
		

 
		if(this.state.clientConfig.jzbFullPage)
		{
			if(window.JZB_JSSDK&&  window.JZB_JSSDK.login)
			{
				fullPage = 1;
			}
		}
		
		if(fullPage)
		{
			$("#feasApp").css("left","0");
			$("#feasApp").css("top","0");
			$("#feasApp").css("z-index",1001);
			
			$("#feasApp").addClass("fullPage");
		}
		
		
		var fromShort=this.getUrlParameter("from");
		
  
			
			if(this.beginInit&&this.state.mainInfo&&this.state.vueloadedCount==(this.fileCount))
			{
				 
				$("#loading-box").removeClass("loading-box-show");
				$("#loading-box").addClass("loading-box-hidden");
				setTimeout(()=>{
					$("#loading-box").hide();
				},2000);
				
				this.stopRefresh =true;
				
				let mainClassName=this.state.clientConfig.mainClassName;
				let showBread = false;
				 
				
			return (
			 
				<div id="jz-main-body" className={`${mainClassName}`} style={{background:'#ffffff',position: 'absolute',top:0,left:0,right:0,bottom:0,display:(!this.state.showReact&&fullPage?'none':'block')}}  >
					<div className={`jz-top-body-header-bg`}></div>
					
					<div id="jz-top-body">
						
						<div >
							<div   style={{paddingLeft: '0px',float:'left'}}> 
							{
								this.state.mainInfo.sys.logo?
								<img className={`mainlogo`} src={this.state.clientConfig.fsUrl+this.state.mainInfo.sys.logo} />
								:
								<img  className={`mainlogo`} 
								src = {window.clientMap.defaultLogo?window.clientMap.defaultLogo:''}
								  /> 
							}
								 
							</div>
							<div  className={`systemTitle`}  >
								  {this.state.mainInfo.systemTitle}
							</div>
							
							{
								window.clientMap.useTopMenu&&<div className={`mainTopMenuClass`}>
								<FsMainMenu onHashChange={this.onHashChange}
								  theme={window.clientMap.theme?window.clientMap.theme:'light'}
								  mode="horizontal"
								  ></FsMainMenu>
							</div>
							}
							
							
							
							
						</div>
						<div style={{'float':'right','marginRight':'10px'}}>
							<Dropdown overlay={(
											  <Menu >
												{!window.SERVER.disableChangePassword&&<Menu.Item key="changepassword" onClick={this.onClickChangePassword} >
												 
													修改密码
												 
												</Menu.Item>}
												
												{window.SERVER.canChangeTheme &&  <Menu.Item key="changeTheme" onClick={this.onClickChangeTheme} >
												 
													切换主题
												 
												</Menu.Item> }
												
												<Menu.Item key="logout" onClick={this.onClickLogout}>
												  退出登录
												</Menu.Item>
												 
											  </Menu>
											)}>
								<a className="ant-dropdown-link" onClick={e => e.preventDefault()} style={{  'lineHeight':'60px',fontSize:'16px'}}>
								 <i className="fa fa-user"></i> {this.state.mainInfo.currentUser.name?this.state.mainInfo.currentUser.name:this.state.mainInfo.currentUser.loginName} <IconFont type="iconDown-Lined" />
								</a>
							  </Dropdown>
						</div>
						
						{
												window.hasPermission("DEV")&&this.state.showDevButton&&!fullPage&&<div className="helpdoc" style={{'float':'right','marginRight':'30px','lineHeight':'60px'}}>  <Button
														onClick={(e)=>{ this.openBottomPage("M::jdccApp/appCenter",{
															height:'95%'
														});    }}
														size={'normal'}
														type={'primary'} 
														> 
												<i className={`fa fa-wrench`} ></i>开发入口
												</Button></div>
												
											 
												
											}
						
						
						{
							window.ServerConfig.helpDocUrl&&<div className="helpdoc" style={{'float':'right','marginRight':'10px','lineHeight':'60px'}}>
							<a  href={window.ServerConfig.helpDocUrl}>帮助文档</a>
							</div>
						}
						
						
						
					</div>
					
					
					<div className={'jz-left-body '+ (window.clientMap.theme?window.clientMap.theme+'-menu':'light-menu')} id="jz-left-body"
					 style={{'display':(window.clientMap.useTopMenu?'none':'block')}}
					 onMouseOver={this.onMenuMouseOver} onMouseOut={this.onMenuMouseOut} >
					 
					    <div className={'jz-left-body-bg'}> 
						</div>
						<div className={'jz-left-body-bg-mask'}>
						</div>
						
						 
						<div className="jz-left-body-menu"  >
						<FsMainMenu onHashChange={this.onHashChange} isCollapse={this.state.isCollapse} theme={window.clientMap.theme?window.clientMap.theme:'light'}></FsMainMenu>
						
						</div>
						
						<div className="jz-left-body-menu-fixed-icon"   > 
						{
							this.state.isFixedMenu?<i className="glyphicon glyphicon-indent-right" onClick={this.fixedMenu} />:
							<i className="glyphicon glyphicon-indent-left" onClick={this.fixedMenu} />
						}
						 
						</div>
						
					</div>
					
					 
					
					{this.state.showReact&&<div className="feasApp-react-main-view" style={{position:'absolute',top:(fullPage?0:'56px'),left:(fullPage?0:'240px'),bottom:0,right:0,zIndex:(fullPage?240:1) ,overflow:'auto',display:(true?'block':'none')}}>
							<FsView    minWidth={window.isMobile?'0':'1200px'}  url={ this.state.currentUrl} parameters={this.state.pageParameters} keepAlive={true} debug={false} isHiddenScroll={true}></FsView>
							 
						</div> }	
					
					 
					<div style={{display:(this.state.showReact?'block':'none')}}>
					<FsWinManager></FsWinManager>
					</div>
					
					 <KinerGuideView   guideStep={0} />
					 
					 
				</div> 
			);
		}
		else
		{
			
			if(!window.SERVER.mainClassName||(window.SERVER&&window.SERVER.mainClassName&&window.SERVER.mainClassName.indexOf("cityos")!=-1)){
				// 如果开启了cityos样式，则显示对应的loading
				$("#loading-box").show();
				
				return <div >  </div>
			}
			else
			{
				return <div style={{width:'100%',height:'100%',textAlign:'center',paddingTop:'300px'}}>
				
				{this.state.loadUrlinfo2?<span>{this.state.loadUrlinfo2}</span>:<Spin tip={""}> 
				 </Spin>} 
				 
				</div>
			}
			
			// if("short"==fromShort) 
			// {
				
			// }
			// else
			// {
			// 	return <div style={{width:'100%',height:'100%',textAlign:'center',paddingTop:'300px'}}>
			// 	{this.state.loadUrlinfo2?<span>{this.state.loadUrlinfo2}</span>:<Spin tip={this.state.loadUrlinfo}>
			// 	 </Spin>}</div>
			// }
			
			 
		}
		
	}

}

export default FsMainFrame;
